<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src="../../assets/snakes.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              RESCUER DETAILS &nbsp;
              <router-link :to="'/sightingsloc1/' + this.id">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>
            </h4>
            <div class="row pt-4">
              <div class="col-2">
                <img
                  :src="image"
                  v-if="image"
                  style="width:150px;height:150px;"
                />
                <enlargeable-image :src="image" :src_large="image">
                  <span>Click me to see the image</span>
                </enlargeable-image>

                <!-- <router-link :to="'/editmyprofile/'+this.userid"> <span class="flex md12 " align="right"><i class="fa fa-pencil"></i></span></router-link> -->
              </div>

              <div class="col-md-5">
                <table class="table table-white flex md12">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Name</th>
                      <td v-if="userdata != null">{{ userdata.name }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Email</th>
                      <td v-if="userdata != null">{{ userdata.email }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Date of Birth</th>
                      <td v-if="userdata.dob != null">
                        {{ userdata.dob.slice(0, 10) }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">BloodGroup</th>
                      <td>{{ data.bloodGroup }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Permanent Address</th>
                      <td>{{ data.permanentAddress }}</td>
                    </tr>
                    <tr>
                      <th scope="col">District</th>
                      <td>{{ data.district }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Any Offense History</th>
                      <td v-if="data.offence == true">Yes</td>
                      <td v-if="data.offence == false">No</td>
                    </tr>
                    <tr v-if="data.offense == true">
                      <th scope="col">Offense Details</th>
                      <td>{{ data.offenceDetails }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescue Started At</th>
                      <td>{{ data.rescueStartedAt }} years</td>
                    </tr>
                    <tr>
                      <th scope="col">Applied Date</th>
                      <td v-if="data.applieddate != null">
                        {{ data.applieddate.slice(0, 10) }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="col">Any Disease</th>
                      <td v-if="data.diseaseStatus == true">Yes</td>
                      <td v-if="data.diseaseStatus == false">No</td>
                    </tr>
                    <tr v-if="data.diseaseStatus == true">
                      <th scope="col">Disease</th>
                      <td>{{ data.diseaseDetails }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-md-5">
                <table class="table table-white flex md12">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">username</th>
                      <td v-if="userdata != null">{{ userdata.username }}</td>
                    </tr>

                    <tr>
                      <th scope="col">Phone</th>
                      <td v-if="userdata != null">{{ userdata.phone }}</td>
                    </tr>

                    <tr>
                      <th scope="col">Organization</th>
                      <td v-if="userdata != null">
                        {{ userdata.organization }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Education</th>
                      <td>{{ data.education }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Employment</th>
                      <td>{{ data.employment }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Present Address</th>
                      <td>{{ data.presentAddress }}</td>
                    </tr>

                    <tr>
                      <th scope="col">Adhar Number</th>
                      <td>{{ data.adharnumber }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Adhar Number Image</th>
                      <td>
                        <img
                          :src="adhar"
                          v-if="adhar"
                          style="width:150px;height:150px;"
                        />
                        <enlargeable-image :src="adhar" :src_large="adhar">
                          <span>Click me to see the image</span>
                        </enlargeable-image>
                      </td>
                      <!-- <p v-else>Not uploaded</p></td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row pt-12">
              <div class="col-md-4">
                <button
                  v-b-modal.modal-footer-sm-approve
                  class="btn btn-success"
                >
                  Click here to approve Rescuer
                </button>
                <b-modal id="modal-footer-sm-approve" title button-size="sm">
                  <form @submit="approve">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Registration Number</label>
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        v-model="rescuerCode"
                        required
                        aria-describedby="emailHelp"
                        placeholder="Registration Number"
                      />
                    </div>
                    <div class="form-group">
                      <label for="exampleInputEmail1">Type</label>
                      <b-form-group horizontal label="Category">
                        <b-form-select v-model="idType" class="mb-3">
                          <option value="Official">Official</option>
                          <option value="Public">Public</option>
                        </b-form-select>
                      </b-form-group>
                    </div>

                    <div class="form-group">
                      <b-form-group horizontal label="Is District Coordinator">
                        <b-form-select
                          v-model="districtCoordinator"
                          class="mb-3"
                        >
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </b-form-select>
                      </b-form-group>
                    </div>

                    <button class="btn btn-success" type="submit">
                      APPROVE
                    </button>
                  </form>
                </b-modal>
              </div>
              <div class="col-md-4">
                <button v-b-modal.modal-footer-sm-reject class="btn btn-danger">
                  Click here to Reject Recuer
                </button>
                <b-modal id="modal-footer-sm-reject" title button-size="sm">
                  <form @submit="reject">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Remarks</label>
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        v-model="reason"
                        required
                        aria-describedby="emailHelp"
                        placeholder="Remarks"
                      />
                    </div>

                    <button class="btn btn-danger" type="submit">REJECT</button>
                  </form>
                </b-modal>
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary" @click="addTraining">
                  Move to Training List
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
export default {
  components: {
    EnlargeableImage
  },
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      image: null,
      name: "",
      data: [],
      userdata: [],
      loading: false,
      data: [],
      im: "",
      rescuerCode: "",
      idType: "",
      idNumber: "",
      reason: "",
      adhar: "",
      districtCoordinator:false,
    };
  },
  mounted: function() {
    this.getview();
  },

  methods: {
    getview() {
      this.loading = true;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/rescuer/get",
        params: { id: this.id }
      })
        .then(response => {
          if (response.data.status === true) {
            this.data = response.data.data;
            this.userdata = response.data.data.user;
            // this.im = response.data.data.user.photo;
            if (response.data.data.user != null) {
              this.image =
                "https://sarpatnapi.leopardtechlabs.in/u/" + response.data.data.user.photo;
            }
            if (response.data.data.adhar != null) {
              this.adhar =
                "https://sarpatnapi.leopardtechlabs.in/u/" + response.data.data.adhar;
            }

            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(err => {
          // this.errors.push(err);
          alert("No Network Found!!");
        });
    },
    approve(evt) {
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data = {};
        data["id"] = this.id;
        data["rescuerCode"] = this.rescuerCode;
        data['districtCoordinator'] = this.districtCoordinator
        data["idType"] = this.idType;
        evt.preventDefault();
        axios({
          method: "POST",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          url: "https://sarpatnapi.leopardtechlabs.in/rescuer/approverescuer/",
          data: data
        })
          .then(response => {
            if (response.data.status) {
              alert("Approved Successfully");
              this.$router.push("/rescuerlist");
            } else {
              alert(response.data.msg);
            }
          })
          .catch(e => {
            console.log(e);
            this.loading = true;
          });
      }
    },
    reject(evt1) {
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data = {};
        data["id"] = this.id;
        data["  "] = this.reason;
        evt1.preventDefault();
        axios({
          method: "POST",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          url: "https://sarpatnapi.leopardtechlabs.in/rescuer/rejectrescuer/",
          data: data
        })
          .then(response => {
            if (response.data.status) {
              alert("Rejected Successfully");
              this.$router.push("/newuserlist");
            } else {
              alert(response.data.msg);
            }
          })
          .catch(e => {
            console.log(e);
            this.loading = true;
          });
      }
    },
    addTraining() {
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data = {};
        data["id"] = this.id;
        axios({
          method: "POST",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          url: "https://sarpatnapi.leopardtechlabs.in/rescuer/movetotraining/",
          data: data
        })
          .then(response => {
            if (response.data.status) {
              alert("Moved to Training List");
              this.$router.push("/newuserlist");
            } else {
              this.loading = false;
              alert(response.data.msg);
            }
          })
          .catch(e => {
            console.log(e);
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style>
.modal-footer {
  display: none !important;
}
.enlargeable-image .enlargeable-image-slot {
  display: inline-block;
}
.enlargeable-image .enlargeable-image-slot > img {
  max-width: 100%;
}
.enlargeable-image > .enlargeable-image-slot {
  max-width: 100%;
  max-height: 100%;
  cursor: zoom-in;
}
.enlargeable-image > .enlargeable-image-slot.active {
  opacity: 0.3;
  filter: grayscale(100%);
}
.enlargeable-image .enlargeable-image-full {
  cursor: zoom-out;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 2000;
  display: none;
}
.enlargeable-image .enlargeable-image-full > img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.enlargeable-image .enlargeable-image-full.enlarging {
  display: flex;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: zoom-out;
}
.enlargeable-image .enlargeable-image-full.delarging {
  display: flex;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: zoom-in;
}
.enlargeable-image .enlargeable-image-full.enlarged {
  display: flex;
}
.enlargeable-image .full.enlarged {
  display: flex;
  position: fixed;
  left: 0;
  top: 50px !important;
  bottom: 50px !important;
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: zoom-out;
  z-index: 200000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/pendingrescuerdetails.vue